export default __webpack_public_path__ + "static/media/smallTriTechLogo.642927e3.svg";